// apiService.js
import { get, post } from "aws-amplify/api";
import currentUserToken from "./CurrentUserToken";

// Fetch alarms
export const fetchAlarms = async (startDate, endDate, states=null, language, accountSelected) => {
  if(accountSelected === undefined || accountSelected === null || accountSelected === "") {
    try {
      const response = await get({
        apiName: "TelemonitoringAPI",
        path: "/alarms",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: {
            start_date: startDate,
            end_date: endDate,
            state: states,
            language: language,        
          },
        },
      });
      const { body } = await response.response;
      return await body.json();
    } catch (error) {
      console.error("Error fetching alarms:", error);
      throw error;
    }
  } else {
    try {
      const response = await get({
        apiName: "TelemonitoringAPI",
        path: "/alarms",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: {
            start_date: startDate,
            end_date: endDate,
            state: states,
            language: language,        
            account_number: accountSelected
          },
        },
      });
      const { body } = await response.response;
      return await body.json();
    } catch (error) {
      console.error("Error fetching alarms:", error);
      throw error;
    }
  }
};
export const tlmPostPinPlantNote = async (noteID, pinnedValue) => {
  try {
    const restOperation = post({
      apiName: "TelemonitoringAPI",
      path: "/accountNumber/plantNote/pin",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          plant_note_id: noteID,
          pin: pinnedValue,
        },
      },
    });
    return restOperation;
  } catch (error) {
    console.error("Errore durante la chiamata API:", error);
  }
};
export const tlmPostPinDeviceNote = async (noteID, pinnedValue) => {
  try {
    const restOperation = post({
      apiName: "TelemonitoringAPI",
      path: "/accountNumber/device/note/pin",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          device_note_id: noteID,
          pin: pinnedValue,
        },
      },
    });
    return restOperation;
  } catch (error) {
    console.error("Errore durante la chiamata API:", error);
  }
};
export const tlmDeletePlantNote = async (noteID) => {
  try {
    const restOperation = post({
      apiName: "TelemonitoringAPI",
      path: "/accountNumber/plantNote/delete",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          plant_note_id: noteID,
        },
      },
    });
    return restOperation;
  } catch (error) {
    console.error("Errore durante la chiamata API:", error);
  }
};
export const tlmDeleteDeviceNote = async (noteID) => {
  try {
    const restOperation = post({
      apiName: "TelemonitoringAPI",
      path: "/accountNumber/device/note/delete",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          device_note_id: noteID,
        },
      },
    });

    return restOperation;
  } catch (error) {
    console.error("Errore durante la chiamata API:", error);
  }
};
export const tlmPostNewPlantNote = async (
  accountNumber,
  pinnedValue,
  remark
) => {
  try {
    const restOperation = post({
      apiName: "TelemonitoringAPI",
      path: "/accountNumber/plantNote/new",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          account_number: accountNumber,
          pin: pinnedValue,
        },
        body: {
          note: remark,
        },
      },
    });
    return restOperation;
  } catch (error) {}
};
export const tlmPostNewDeviceNote = async (
  accountNumber,
  alarmTypeId,
  originalEquipment,
  remark
) => {
  try {
    // Sostituire null con una stringa vuota
    const sanitizedOriginalEquipment = originalEquipment || "";

    const restOperation = post({
      apiName: "TelemonitoringAPI",
      path: "/accountNumber/device/note/new",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {},
        body: {
          account_number: accountNumber,
          note: remark,
          alarm_type_id: alarmTypeId,
          original_equipment: sanitizedOriginalEquipment, // Utilizzare il valore "sanitized"
        },
      },
    });
    return restOperation;
  } catch (error) {
    console.error("Errore durante la chiamata API:", error);
  }
};

export const fetchSingleAlarm = async (alarmID, language) => {
  try {
    const response = await get({
      apiName: "TelemonitoringAPI",
      path: "/alarms",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          alarm_id: alarmID,
          language: language,
        },
      },
    });
    const { body } = await response.response;
    return await body.json();
  } catch (error) {
    console.error("Error fetching alarms:", error);
    throw error;
  }
};

export const fetchAlarmsOnSameDevice = async (
  accountNumber,
  language,
  startDateTimeUTC,
  endDateTimeUTC
) => {
  try {
    const response = await get({
      apiName: "TelemonitoringAPI",
      path: "/alarms",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          start_date: startDateTimeUTC,
          end_date: endDateTimeUTC,
          account_number: accountNumber,
          language: language,
        },
      },
    });
    const { body } = await response.response;
    return await body.json();
  } catch (error) {
    console.error("Error fetching alarms:", error);
    throw error;
  }
};
export const tlmGetEventHistory = async (startDate, endDate, Alarm_ID) => {
  try {
    const formattedStartDate = startDate.format('YYYY-MM-DD 00:00:00');
    const formattedEndDate = endDate.format('YYYY-MM-DD 23:59:59');
    const response = await get({
      apiName: "TelemonitoringAPI",
      path: "/eventHistory/get",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          start_date: formattedStartDate,
          end_date: formattedEndDate,
          alarm_id:Alarm_ID
        },
      },
    });
    const { body } = await response.response;
    return await body.json();
  } catch (error) {
    console.error("Error fetching alarms:", error);
    throw error;
  }
};
export const tlmGetAccountAssets = async (accountID) => {
  try {
    const response = await get({
      apiName: "TelemonitoringAPI",
      path: "/accountNumber/asset",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          account_id: accountID,
          record_type_id: "0126N000000ChTeQAK",
        },
      },
    });
    const { body } = await response.response;
    return await body.json();
  } catch (error) {
    console.error("Error fetching alarms:", error);
    throw error;
  }
};
export const tlmGetPlantNotes = async (accountNumber, endDate, startDate) => {
  try {
    const formattedStartDate = startDate.format("YYYY-MM-DD");
    const formattedEndDate = endDate.format("YYYY-MM-DD");
    const response = await get({
      apiName: "TelemonitoringAPI",
      path: "/accountNumber/plantNote/get",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          account_number: accountNumber,
        },
      },
    });
    const { body } = await response.response;
    return await body.json();
  } catch (error) {
    console.error("Error fetching alarms:", error);
    throw error;
  }
};
export const tlmGetDeviceNote = async (accountNumber, endDate, startDate,language) => {
  try {
    const formattedStartDate = startDate.format("YYYY-MM-DD");
    const formattedEndDate = endDate.format("YYYY-MM-DD");
    const response = await get({
      apiName: "TelemonitoringAPI",
      path: "/accountNumber/device/note/get",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          account_number: accountNumber,
          start_date: "",
          end_date: "",
          language: language
        },
      },
    });
    const { body } = await response.response;
    return await body.json();
  } catch (error) {
    console.error("Error fetching alarms:", error);
    throw error;
  }
};
export const tlmGetProcessNotes = async (accountNumber, endDate, startDate, language) => {
  try {
    const formattedStartDate = startDate.format("YYYY-MM-DD");
    const formattedEndDate = endDate.format("YYYY-MM-DD");
    const response = await get({
      apiName: "TelemonitoringAPI",
      path: "/alarm/processNote/get",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          account_number: accountNumber,
          start_date: formattedStartDate,
          end_date: formattedEndDate,
          language: language,
        },
      },
    });
    const { body } = await response.response;
    return await body.json();
  } catch (error) {
    console.error("Error fetching alarms:", error);
    throw error;
  }
};
export const tlmGetProcessNotesAlarm = async (accountNumber, endDate, startDate, OriginalEquipment, language) => {
  try {
    const formattedStartDate = startDate.format("YYYY-MM-DD");
    const formattedEndDate = endDate.format("YYYY-MM-DD");
    const response = await get({
      apiName: "TelemonitoringAPI",
      path: "/alarm/processNote/get",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          account_number: accountNumber,
          start_date: formattedStartDate,
          end_date: formattedEndDate,
          original_equipment: OriginalEquipment,
          language: language
        },
      },
    });
    const { body } = await response.response;
    return await body.json();
  } catch (error) {
    console.error("Error fetching alarms:", error);
    throw error;
  }
}
export const tlmGetAccountNumberEquipment = async (
  accountNumber,
) => {
  try {
    const response = await get({
      apiName: "TelemonitoringAPI",
      path: "/accountNumber/equipment/get",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          account_number: accountNumber,
        },
      },
    });
    const { body } = await response.response;
    return await body.json();
  } catch (error) {
    console.error("Error fetching alarms:", error);
    throw error;
  }
};

export const fetchAccNumberContacts = async (accountID) => {
  try {
    const response = await get({
      apiName: "TelemonitoringAPI",
      path: "/accountNumber/contact/get",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          account_id: accountID,
        },
      },
    });
    const { body } = await response.response;
    return await body.json();
  } catch (error) {
    console.error("Error fetching alarms:", error);
    throw error;
  }
};

export const fetchResourcePref = async (accountID) => {
  try {
    const response = await get({
      apiName: "TelemonitoringAPI",
      path: "/accountNumber/resourcePreference",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          account_id: accountID,
        },
      },
    });
    const { body } = await response.response;
    return await body.json();
  } catch (error) {
    console.error("Error fetching alarms:", error);
    throw error;
  }
};
export const tlmPostAccountNumberInactive = async (accountNumber, endDate) => {
  try {
    const response = post({
      apiName: "TelemonitoringAPI",
      path: "/accountNumber/status/inactive",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          account_number: accountNumber,
          end_date: endDate
        },
      },
    });

    return response;
  } catch (error) {
    console.error("Error confirming charge:", error);
    throw error;
  }
};
export const tlmPostAccountNumberActive = async (accountNumber) => {
  try {
    const response = post({
      apiName: "TelemonitoringAPI",
      path: "/accountNumber/status/active",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        body: {
        },
        queryParams: {
          account_number: accountNumber,
        },
      },
    });

    return response;
  } catch (error) {
    console.error("Error confirming charge:", error);
    throw error;
  }
};
// Confirm taking charge of an alarm
export const confirmAlarmCharge = async (alarmId) => {
  try {
    const response = post({
      apiName: "TelemonitoringAPI",
      path: "/alarm/takeInCharge/self",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        body: {
          alarm_ids: alarmId,
        },
        queryStringParameters: {},
      },
    });

    return response;
  } catch (error) {
    console.error("Error confirming charge:", error);
    throw error;
  }
};
export const tlmPostAlarmSuspensionReactive = async (alarmIds) => {
  try {
    const response = post({
      apiName: "TelemonitoringAPI",
      path: "/alarm/suspension/reactive",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        body: {
          alarm_ids: alarmIds, // Use alarm_ids as an array
        },
        queryStringParameters: {},
      },
    });

    return response;
  } catch (error) {
    console.error("Error confirming charge:", error);
    throw error;
  }
};
export const confirmAlarmClose= async (alarmId, combinedRemark,selectedTypeCloseId) => {
  try {
    const response = post({
      apiName: "TelemonitoringAPI",
      path: "/alarm/close",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        body: {
          alarm_ids: alarmId,
          note: combinedRemark,
          pattern_type_id: selectedTypeCloseId,
        },
        queryStringParameters: {},
      },
    });

    return response;
  } catch (error) {
    console.error("Error confirming charge:", error);
    throw error;
  }
};
export const tlmPostNewAlarmSuspension = async (alarmId, remark2, utcEndDate, calendarId, isLocked) => {

  try {
    const response = post({
      apiName: "TelemonitoringAPI",
      path: "/alarm/suspension/new",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        body: {
          alarm_ids: alarmId,
          note: remark2,
        },
        queryParams: {
          lock: isLocked,
          end_date: utcEndDate,
          calendar_id:calendarId
        },
      },
    });

    return response;
  } catch (error) {
    console.error("Error confirming charge:", error);
    throw error;
  }
};

export const saveAlarmRemark = async (alarmIds, combinedRemark) => {
  try {
    const response = await post({
      apiName: "TelemonitoringAPI",
      path: "/alarm/note/new",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        body: {
          alarm_ids: alarmIds,
          note: combinedRemark,  // Usa combinedRemark qui
        },
      },
    });
    return response;
  } catch (error) {
    console.error("Error confirming charge:", error);
    throw error;
  }
};

// Create a Salesforce case for an alarm
export const createSalesforceCase = async (alarmId, formData) => {
  try {
    const response = await post("TelemonitoringAPI", "/salesforce/postCase", {
      headers: {
        "Content-Type": "application/json",
      },
      queryStringParameters: {
        alarm_id: alarmId,
      },
      body: {
        caseorigin: formData.caseorigin,
        type: formData.type,
        subtype: formData.subtype,
        subject: formData.subject,
        description: formData.description,
        account_number: formData.account_number,
        asset: formData.asset,
        salesorganization: formData.salesorganization,
      },
    });

    return response;
  } catch (error) {
    console.error("Error creating Salesforce case:", error);
    throw error;
  }
};

export const getCustomerForm = async (fileName) => {
  try {
    const response = await get({
      apiName: "TelemonitoringAPI",
      path: "/object/customerForm/get",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          file_name: fileName,
        },
      },
    });
    const { body } = await response.response;
    return await body.json();
  } catch (error) {
    console.error("Error fetching customer object:", error);
    throw error;
  }
};

export const tlmGetDeviceNoteAlarm = async (accountNumber, endDate, startDate, AlarmTypeID, OriginalEquipment, language) => {
  try {
    const formattedStartDate = startDate.format("YYYY-MM-DD");
    const formattedEndDate = endDate.format("YYYY-MM-DD");
    const response = await get({
      apiName: "TelemonitoringAPI",
      path: "/accountNumber/device/note/get",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          account_number: accountNumber,
          start_date: "",
          end_date: "",
          original_equipment: OriginalEquipment,
          language: language
        },
      },
    });
    const { body } = await response.response;
    return await body.json();
  } catch (error) {
    console.error("Error fetching alarms:", error);
    throw error;
  }
}
export const tlmGetAlarmRate = async (alarmId) => {
  try {
    const response = await get({
      apiName: "TelemonitoringAPI",
      path: "/alarm/frequency",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          alarm_id: alarmId
        },
      },
    });
    const { body } = await response.response;
    return await body.json();
  } catch (error) {
    console.error("Error fetching alarms:", error);
    throw error;
  }
}
export const tlmGetWorkType = async (code) => {
  try {
    const response = await get({
      apiName: "TelemonitoringAPI",
      path: "/workType/get",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          country_code : code
        },
      },
    });
    const { body } = await response.response;
    return await body.json();
  } catch (error) {
    console.error("Error fetching alarms:", error);
    throw error;
  }
};
